module.exports = __webpack_public_path__ + "static/img/iphone2.ec33b50.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/iphone2.png
// module id = /B3F
// module chunks = 1